export default "__VITE_ASSET__D4g2vlpM__"